<template>
  <draggable v-model="tagList" tag="ul" handle=".line" ghost-class="ghost">
    <li
      :class="['line', { 'line-edit': editTagId === tag.id }]"
      v-for="tag in tagList"
      :key="tag.id"
    >
      <div class="left-group">
        <TagSvgWithColor
          :tag="isCurrentlyEditable(tag.id) ? newTagProps : tag"
        />
        {{ isCurrentlyEditable(tag.id) ? newTagProps.name : tag.name }}
      </div>
      <div class="right-group">
        <span>{{ getTagCount(tag.id) }}</span>
        <button
          :style="{ display: editTagId === tag.id ? 'none' : 'flex' }"
          @click.prevent="handleEdit(tag.id)"
        >
          <PenIcon color="#7D919B" />
        </button>
        <button
          :style="{ display: editTagId === tag.id ? 'flex' : 'none' }"
          @click.prevent="handleCancelEdit"
        >
          <ico name="icoClose" color="#7D919B" size="19" />
        </button>
        <button
          v-if="tagList.length > 1"
          @click.prevent.stop="handleDelete(tag.id)"
        >
          <ico name="icoDelete" color="#7D919B" size="19" />
        </button>
      </div>
    </li>
  </draggable>
</template>

<script>
import draggable from "vuedraggable";
import { mapGetters, mapActions } from "vuex";
import TagSvgWithColor from "./TagSvgWithColor.vue";
import api from "@/application";
import PenIcon from "@/assets/icons/pen-icon.svg";

export default {
  name: "TagList",
  data() {
    return { tagsInfo: [] };
  },
  components: { draggable, TagSvgWithColor, PenIcon },
  props: {
    editTagId: { type: [Number, null], required: true },
    newTagProps: { type: Object, required: true },
  },
  computed: {
    ...mapGetters("tags", ["tags", "forms"]),
    ...mapGetters("profile", ["profileId"]),
    tagList: {
      get() {
        return this.tags;
      },
      set(value) {
        const newPriority = value.map((tag) => ({
          id: tag.id,
          name: tag.name,
          color: tag.color,
          form: tag.form,
          profileId: this.profileId,
        }));
        this.updateTagPriority(newPriority);
      },
    },
  },
  methods: {
    ...mapActions("tags", ["deleteTag", "updateTagPriority"]),
    handleEdit(id) {
      this.$emit("editTag", id);
    },
    handleCancelEdit() {
      this.$emit("editTag", null);
    },
    async handleDelete(id) {
      this.$emit("deleteTag", id, await this.getTagCount(id));
    },
    isCurrentlyEditable(id) {
      return this.editTagId === id;
    },
    getTagCount(tagId) {
      const tagInfo = this.tagsInfo.find((tag) => tag.id === tagId);
      return tagInfo?.lotCount || 0;
    },
  },
  mounted() {
    api.tags.getLotCount(this.profileId).then((res) => {
      this.tagsInfo = res.data;
    });
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/commonStyles.less";

.line {
  user-select: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  transition: background-color 0.3s ease;

  &:hover {
    &:not(.line-edit) {
      background-color: #f6f7f8;
    }
    .right-group {
      opacity: 1;
      visibility: visible;
    }
  }

  &-edit {
    background-color: #edeff1;
  }
  &&-edit {
    .right-group {
      opacity: 1;
      visibility: visible;
    }
  }

  .left-group {
    display: flex;
    gap: 23px;
    margin-left: 32px;
  }

  .right-group {
    display: flex;
    align-items: center;
    margin-right: 32px;
    gap: 15px;
    color: #7d919b;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, transform 0.3s ease;

    span {
      height: 19px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 2px;
    }

    button {
      width: 19px;
      height: 19px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
